import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getRegisterToken = api(() =>
    query(
        gql`
            query GetRegisterToken {
                getRegisterToken
            }
        `,
        {},
        { returns: "getRegisterToken" }
    )
)
